<docs>
## YuCurrency Docs

* 一个页面可能显示多种货币，所以货币符号直接输出成单个元素
* 利用 slot 避免 toFixed(2) 问题（自己控制精度）
</docs>

<template>
  <span class="yu-currency" data-com='YuCurrency'>
    <span v-if="val < 0">-</span>
    <i v-if="symbol" class="yu-currency-symbol">{{symbol}}</i>
    <span>{{Math.abs(val / 100).toFixed(decimal)}}</span>
  </span>
</template>

<script>
export default {
  componentName: 'YuCurrency',
  props: {
    val: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'CNY'  // 根据 $shop.currency
    },
    symbol: {
      type: String,
      default: '¥'  // 根据 $shop.currency_symbol
    },
    decimal: {
      type: Number,
      default: 2
    }
  }
}
</script>

<style>
  .yu-currency-symbol {
    font-family: 'Arial';
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// Currency.vue?95bb59aa